/* eslint-disable max-len */
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

import { navMenu, updateSpecificUrlPath } from "../../utils/Constant"
import { userRoles } from "../Utility/userRoles"

const NavBar = () => {
    const { t } = useTranslation()
    const loginDetails = sessionStorage.getItem("userDetails")
    const loggedInUserType = loginDetails
        ? JSON.parse(loginDetails)?.user_details
        : {}
    const { base_sales_org_code, roles, user_type } = loggedInUserType ||  {}

    const[finalMenu, setFinalMenu] = useState([])
    const[itemName, setItemName] = useState("")

    useEffect(() => {
        const updatedMenu = navMenu(loggedInUserType?.user_type, logedInSecondary)
        setFinalMenu(updatedMenu)
    },[loggedInUserType?.user_type])

    const isActiveMenu = (permissionId) => {
        if (Array.isArray(permissionId)) {
            let permissionArray = permissionId?.map((key) => {
                let permission = userRoles().findUserRolesForPage(key)
                return permission?._read
            })
            return permissionArray.includes(true)
        } else {
            const permission = userRoles().findUserRolesForPage(permissionId)
            return !!(permission?._read || permission?._write || permission?._delete)
        }
    }

    const userDetails = loggedInUserType?.service_center_details?.find((record)=>{
        return record.function.includes("warranty")
    })
    const logedInSecondary = userDetails?.type === "Secondary" ? true : false

    updateSpecificUrlPath(finalMenu)

    const handleClick = (e, item) => {
        e.preventDefault()
        if(e.keyCode === 13){
            setItemName(item?.name)
        } 
        if(e.keyCode === 27){
            setItemName("")
        } 
    }

    const navMenuLinks = finalMenu.map((item, i) => {
        const hasActiveMenu = isActiveMenu(item?.activity_id)
        return (
            <li key={ `menu_${i}` } onKeyUp={ (e)=> handleClick(e, item) } className={ `relative hover:underline group ${!hasActiveMenu ? "hidden" : ""}` }>
                {
                    hasActiveMenu ? <NavLink to={ item.url } className="text-white text-sm font-bold capitalize py-2 flex">
                        { t(`Navigation.${item.name}`) }
                    </NavLink> : <></>
                }
                { item?.subMenu && (
                    <ul className={ `absolute bg-white py-2 shadow-md min-w-[200px] ${ item?.name === itemName ? "": "hidden" } group-hover:flex flex-col` }>
                        { item?.subMenu.map((subItem, index) => {
                            if (isActiveMenu(subItem?.activity_id)) {
                                return (
                                    <li key={ `menukey_${subItem?.activity_id}_${index}` }>
                                        {
                                            <NavLink
                                                to={ subItem.url }
                                                className="text-primary-100 text-sm  capitalize px-4 py-2 flex whitespace-nowrap hover:underline"
                                            >
                                                { t(`Navigation.${subItem.name}`) }
                                            </NavLink>
                                        }

                                    </li>
                                )
                            }
                        }) }
                    </ul>
                ) }
            </li>
        )
    })

    return (
        <div className="flex bg-primary-100 px-8 nav">
            {
                (user_type==1 || (user_type==2 && base_sales_org_code && roles)) ? (
                    <ul className="flex gap-8">{ navMenuLinks }</ul>
                ) : <></>
            }
            
        </div>
    )
}

export default NavBar
